import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faCheck,
  faRedo,
} from '@fortawesome/free-solid-svg-icons';

const RightSidebarMock = () => (
  <div className="rounded-lg overflow-hidden shadow-2xl shadow-black/30 border border-white/[0.06] font-mono" style={{ background: '#0f1923' }}>
    <div className="p-4 space-y-3">
      {/* Walk-Forward Validation */}
      <div className="bg-white/[0.03] rounded-lg p-3 space-y-2">
        <h5 className="text-xs font-medium text-gray-500 uppercase tracking-wide">Walk-Forward Validation</h5>
        <div className="flex items-center justify-between">
          <span className="text-gray-400 text-sm">Outcome</span>
          <span className="text-lg font-semibold text-emerald-400">Passed</span>
        </div>
      </div>

      {/* Validation Depth */}
      <div className="bg-white/[0.03] rounded-lg p-3 space-y-2">
        <h5 className="text-xs font-medium text-gray-500 uppercase tracking-wide">Validation Depth</h5>
        <div className="text-sm text-gray-300">
          <span className="text-white font-semibold">4 / 5</span> windows passed
        </div>
        <div className="text-xs text-emerald-400">
          Minimum depth met (3+ windows)
        </div>
      </div>

      {/* Out-of-Sample Performance */}
      <div className="bg-white/[0.03] rounded-lg p-3 space-y-2">
        <h5 className="text-xs font-medium text-gray-500 uppercase tracking-wide">Out-of-Sample Performance</h5>
        <div className="grid grid-cols-2 gap-2 text-sm">
          {[
            { label: 'Total OOS Return', value: '+18.4%', color: 'text-emerald-400' },
            { label: 'Avg Sharpe', value: '1.32', color: 'text-white' },
            { label: 'Max Drawdown', value: '-12.6%', color: 'text-amber-400' },
            { label: 'WFE', value: '72%', color: 'text-emerald-400' },
          ].map((m) => (
            <div key={m.label}>
              <div className="text-xs text-gray-500">{m.label}</div>
              <div className={`font-medium ${m.color}`}>{m.value}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Improvement Guidance */}
      <div className="bg-white/[0.03] rounded-lg p-3 space-y-2">
        <h5 className="text-xs font-medium text-gray-500 uppercase tracking-wide">Improvement Guidance</h5>
        <ul className="space-y-1">
          {[
            'Consider increasing validation depth to 5+ windows',
            'Monitor drawdown recovery in next OOS window',
          ].map((message, idx) => (
            <li key={idx} className="text-sm text-gray-300 flex items-start gap-2">
              <span className="text-purple-400">{'\u25B6'}</span>
              <span className="text-purple-300 font-medium">{message}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Research Pipeline */}
      <div className="bg-white/[0.03] rounded-lg p-3 space-y-2">
        <h5 className="text-xs font-medium text-gray-500 uppercase tracking-wide">Research Pipeline</h5>
        <div className="text-xs text-gray-400 mb-2">
          Optimization v1 &rarr; <span className="text-cyan-400">Walk-Forward Analysis</span>
        </div>
        <div className="space-y-1.5">
          {[
            { label: 'Optimization', done: true },
            { label: 'Walk-Forward Analysis', done: true },
            { label: 'Adaptive Flow', done: false, running: true },
          ].map((step) => (
            <div key={step.label} className="flex items-center gap-2 text-sm">
              <FontAwesomeIcon
                icon={faCheck}
                className={`w-3 h-3 ${step.done ? 'text-emerald-400' : 'text-gray-600'}`}
              />
              <span className="text-gray-300">{step.label}</span>
              {step.running && (
                <span className="flex items-center gap-1 ml-auto text-xs text-emerald-400">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
                  Running
                </span>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Controls */}
      <div className="pt-3 border-t border-gray-700 space-y-2">
        <div className="w-full flex items-center justify-center gap-2 px-4 py-2 border border-gray-600/30 text-gray-300 rounded-lg font-medium text-sm">
          <FontAwesomeIcon icon={faArrowLeft} />
          Back to Optimization
        </div>
        <div className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-purple-600 text-white rounded-lg font-medium text-sm">
          <FontAwesomeIcon icon={faRedo} />
          Re-run Walk-Forward Analysis
        </div>
      </div>
    </div>
  </div>
);

export default RightSidebarMock;
